/*
 * @Author: your name
 * @Date: 2020-03-23 11:25:59
 * @LastEditTime: 2020-11-19 10:06:13
 * @LastEditors: wutt
 * @Description: In User Settings Edit
 * @FilePath: /DianZiDiTu/src/components/onlineMap/model/DataSource/DataSourceInfoJs.js
 */

import AxiosConfig from "../../../../config/AxiosConfigJs";
import { GuidUtility } from "../../../../utility/common/GuidUtility";


export class DataSourceInfo {
    
    constructor() {

        this.id = GuidUtility.getGuid();

        this.name = null;

        //数据源类型
        this.type = null;

        this.description = null;

        //openlayers数据源
        this.olSource = null;
    }

    /**
     *虚方法，
     */
    getGeometryType() {

    }

    /**
     * 虚方法
     */
    getFields() {

    }

    /**
     * 获取数值型
     */
    getNumberFields() {

    }



    /**
     * 虚方法，创建openlayers 数据源
     * @param {*} rendererType 
     */
    getOLSource(rendererType) {
        if (!rendererType) return;

    }

    /**
     * 虚方法
     */
    getRequestObject()
    {   
        

    }



    /**
    * 从jsonobject对象中获取基类的基本信息
    * @param {*} layerItem 
    * @param {*} jsonObject 
    */
    static getBasicInfofromJson(layerItem, jsonObject) {

        if (!jsonObject) return layerItem;

        layerItem.id = jsonObject.id;
        layerItem.name = jsonObject.name;
        layerItem.type = jsonObject.type;
        layerItem.description = jsonObject.description;

    }

    /**
    * 
    * @param {*} filter 
    * @param {*} succeedCallback 
    * @param {*} errorCallback 
    */
    static getDataSource(filter, url, succeedCallback, errorCallback) {
        AxiosConfig.subjectConfig
            .post(url, filter)
            .then(function (response) {
                var responseResult = null;
                if (response != null && response.data) {
                    responseResult = response.data.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }
    

}


export class DataSourceInfoFilter {
    constructor() {
        this.id = null; // 唯一值
        this.ids = null;
        this.paginationCount = 1; // 分页总数
        this.paginationStart = 0; // 分页起始索引
        this.type = null;
        this.useId = false; // 是否使用唯一值 
        this.useIds = false;	  // 是否使用ids
        this.usePagination = false;	 // 是否使用分页
        this.useType = false;	// 是否使用类型
        this.useTypes = false;	// 是否使用类型集合
    }
}


export const DataSourceType =
{   
    spatialFile:"spatialFile",

    spatialFile_shapeFile: "shapeFile",

    spatialFile_kmlFile: "kmlFile",

    //csv文件
    spatialFile_csvFile: "csvFile",

    //excel文件
    spatialFile_excelFile:'excelFile',

    service_vectorTile: "vectorTile",


    service_wmts: "wmts",

    service_wms:"wms",

    service_wfs: "wfs",

    engine_source: "engine_source",

    map_plotting: "map_plotting",
    

    sourceTypeLabels:
    [   
        {
            id: 0,
            label: "文件",
            value: "spatialFile"
        },
        {
            id: 1,
            label: "矢量切片服务",
            value: "vectorTile"
        },

        {
            id:2,
            label: "wmts服务",
            value: "wmts"
        },

        {
            id: 3,
            label: "WFS OGC Web服务",
            value: "wfs"
        },

        {
            id: 4,
            label: "服务引擎",
            value: "engine_source"
        }
        ,
        {
            id:5,
            label: "wms服务",
            value: "wms"
        }

    ],


    dataTypeLabels:
        [
            {
                id: 0,
                label: "shp文件",
                value: "shapeFile"
            },
            {
                id: 1,
                label: "kml文件",
                value: "kmlFile"
            },

            {
                id:2,
                label: "csv文件",
                value: "csvFile"
            },

            {
                id: 3,
                label: "WFS OGC Web服务",
                value: "wfs"
            },

            {
                id: 4,
                label: "矢量切片服务",
                value: "vectorTile"
            },

            {
                id: 5,
                label: "wmts服务",
                value: "wmts"
            },

            {
                id: 6,
                label: "服务引擎",
                value: "engine_source"
            },
            {
                id: 7,
                label: "wms服务",
                value: "wms"
            },
        ],


    spatialFileDataTypeLabels:
        [
            {
                id: 0,
                label: "shp文件",
                value: "shapeFile"
            },
            
            {
                id: 1,
                label: "kml文件",
                value: "kmlFile"
            },

            {
                id: 4,
                label: "csv文件",
                value: "csvFile"
            },

            {
                id: 5,
                label: "excel文件",
                value: "excelFile"
            }

        ],


    epsgLabels:
        [
            {
                id: 0,
                label: "4326",
                value: "EPSG:4326"
            },

            {
                id: 1,
                label: "3857",
                value: "EPSG:3857"
            },
            {
                id: 2,
                label: "4490",
                value: "EPSG:4490"
            },
        ],

    wfsVersionLabels:
        [
            {
                id: 0,
                label: "WFS 1.0.0",
                value: "1.0.0"
            },
            {
                id: 1,
                label: "WFS 1.1.0",
                value: "1.1.0"
            },
            {
                id: 2,
                label: "WFS 2.0.0",
                value: "2.0.0"
            }

        ],

        wmsVersionLabels:
        [   
            {
                id: 0,
                label: "WMS 1.0.0",
                value: "1.0.0"
            },
            {
                id: 1,
                label: "WMS 1.1.0",
                value: "1.1.0"
            },
            {
                id: 2,
                label: "WMS 1.1.1",
                value: "1.1.1"
            },
            {
                id: 2,
                label: "WMS 1.3.0",
                value: "1.3.0"
            }
            
        ]

}
